import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Phase M (m-core): Denwen MSP Monitor. Settings ▸ Monitoring ▸ Probes is mounted by
// the admin layout (modules/admin/routes.tsx); the Monitoring tab lives inside an organization.
export const settingsRoutes: RouteObject[] = [
  { path: 'monitoring-probes', lazy: page(() => import('./probes-page'), (m) => m.ProbesPage) },
  { path: 'monitoring-credentials', lazy: page(() => import('./credentials-page'), (m) => m.CredentialsPage) },
  // Phase M (m-alerts): the alert console and alert policies.
  { path: 'monitoring-alerts', lazy: page(() => import('./alert-settings-page'), (m) => m.MonitoringAlertsPage) },
  // Phase M (m-cloud-checks, M7): the template library and editor.
  { path: 'monitoring-templates', lazy: page(() => import('./templates-page'), (m) => m.TemplatesPage) },
  { path: 'monitoring-templates/:id', lazy: page(() => import('./templates-page'), (m) => m.TemplateDetailPage) },
  // fix-monitor (audit Track 2): trap and syslog rules.
  { path: 'monitoring-event-rules', lazy: page(() => import('./event-rules-page'), (m) => m.EventRulesPage) },
];

// Phase M (m-ui: M9): the Monitor UI. The public status page (/status/:slug) is mounted outside
// the app shell in app/router.tsx, and the portal view (/portal/monitoring) by the portal routes.
export const routes: RouteObject[] = [
  { path: 'monitoring', lazy: page(() => import('./home-page'), (m) => m.MonitoringHomePage) },
  { path: 'monitoring/alerts', lazy: page(() => import('./alerts-page'), (m) => m.AlertsPage) },
  { path: 'monitoring/maintenance', lazy: page(() => import('./maintenance-page'), (m) => m.MaintenancePage) },
  { path: 'monitoring/status-pages', lazy: page(() => import('./status-pages'), (m) => m.StatusPagesPage) },
];
export const orgRoutes: RouteObject[] = [
  { path: 'monitor', lazy: page(() => import('./org-monitoring'), (m) => m.OrgMonitoringPage) },
  { path: 'monitor/topology', lazy: page(() => import('./topology-page'), (m) => m.TopologyPage) },
  { path: 'monitor/alerts', lazy: page(() => import('./alerts-page'), (m) => m.OrgAlertsPage) },
  { path: 'monitor/devices/:deviceId', lazy: page(() => import('./device-page'), (m) => m.DevicePage) },
  // Phase M (m-probe: M6): network discovery and its review queue.
  { path: 'monitor/discovery', lazy: page(() => import('./discovery-page'), (m) => m.OrgDiscoveryPage) },
];

/** Customer portal: Monitoring (Portal Managers). Spread into the portal's routes. */
export const portalMonitoringRoute: RouteObject = { path: 'monitoring', lazy: page(() => import('./portal-monitoring'), (m) => m.PortalMonitoringPage) };
/** Public status page, no sign-in. */
export const publicStatusRoute: RouteObject = { path: '/status/:slug', lazy: page(() => import('./public-status-page'), (m) => m.PublicStatusPage) };
